/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_MenusInputs */

const en_for_whom_tag_menus = /** @type {(inputs: For_Whom_Tag_MenusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meal plans`)
};

const pl_for_whom_tag_menus = /** @type {(inputs: For_Whom_Tag_MenusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadłospisy`)
};

/**
* | output |
* | --- |
* | "Meal plans" |
*
* @param {For_Whom_Tag_MenusInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_menus = /** @type {((inputs?: For_Whom_Tag_MenusInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_MenusInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_menus(inputs)
	return en_for_whom_tag_menus(inputs)
});